/* eslint-disable import/prefer-default-export */
import client from '../../api';
import { roles } from '../../api/endpoints';

const endpoint = roles.index;

export const loadRoles = () => client.get(endpoint);
